import { Box, Stack } from '#core/components';
import { useTagsStore } from '#domains/tags';
import { TreeTagsSearchProvider, useTreeTagsSearch } from '#features/tags';
import {
  VirtualScroll,
  VirtualScrollProvider
} from '#shared/modules/virtual-scroll';
import { Collections, Main, TagRow, TagSectionHeader } from './sections';

import styles from './MainNav.module.css';

const MainNavContent = () => {
  const { filteredTags } = useTreeTagsSearch();

  return (
    <VirtualScroll
      components={{
        Header: () => {
          return (
            <Stack className={styles.sections}>
              <Main />
              <Collections />
              <TagSectionHeader />
            </Stack>
          );
        }
      }}
      data={filteredTags}
      itemContent={(_, tag) => <TagRow tag={tag} />}
      totalCount={filteredTags.length}
    />
  );
};

export const MainNav = () => {
  const tags = useTagsStore(state => state.treeTags);

  return (
    <Box className={styles.mainNav}>
      <TreeTagsSearchProvider expanded={false} tags={tags}>
        <VirtualScrollProvider>
          <MainNavContent />
        </VirtualScrollProvider>
      </TreeTagsSearchProvider>
    </Box>
  );
};
